// Frontend-only access control.
//
// NOTE: This restriction only hides UI. It does NOT secure the backend APIs.
// A restricted user who knows the API endpoints could still call them directly
// with their token. For real enforcement the backend must also reject
// template/category requests for non-main-admin accounts.
//
// Only the main admin(s) below can see the full dashboard (Dashboard, Add
// Template, Categories, Users). Every other logged-in admin can ONLY see the
// Users screen.
export const FULL_ADMIN_EMAILS: string[] = [
  "admin@aiposter.com",
];

/**
 * Returns true if the given email belongs to a main/full admin who can see
 * every feature.
 */
export const isFullAdmin = (email: string | null | undefined): boolean => {
  if (!email) return false;
  const normalized = email.trim().toLowerCase();
  return FULL_ADMIN_EMAILS.some(
    (allowed) => allowed.trim().toLowerCase() === normalized
  );
};

/**
 * Returns true if the given email should only see the Users screen,
 * i.e. any logged-in admin that is not a main/full admin.
 */
export const isUsersOnlyAdmin = (email: string | null | undefined): boolean => {
  return !isFullAdmin(email);
};
